var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndergroundWinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 24H30V60H36V24Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39H15V45H51V39Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8788 27.878L18.8796 51.8772L23.1222 56.1199L47.1214 32.1207L42.8788 27.878Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6734 27.758L18.459 32.0287L42.8909 56.1386L47.1053 51.8679L22.6734 27.758Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105 105H102C96.8375 105 94.075 103.028 91.855 101.44C89.87 100.022 88.4375 99 85.1975 99C81.9575 99 80.525 100.025 78.54 101.44C76.32 103.025 73.5575 105 68.395 105C63.2325 105 60.47 103.028 58.25 101.44C56.265 100.022 54.8325 99 51.595 99C48.3575 99 46.9225 100.025 44.94 101.44C42.72 103.025 39.9575 105 34.7975 105C29.6375 105 26.875 103.028 24.655 101.44C22.67 100.022 21.2375 99 18 99H15V93H18C23.16 93 25.9225 94.9725 28.1425 96.56C30.1275 97.9775 31.56 99 34.7975 99C38.035 99 39.47 97.975 41.4525 96.56C43.6725 94.975 46.435 93 51.595 93C56.755 93 59.52 94.9725 61.7375 96.56C63.7225 97.9775 65.155 99 68.395 99C71.635 99 73.0675 97.975 75.0525 96.56C77.2725 94.975 80.035 93 85.1975 93C90.36 93 93.1225 94.9725 95.3425 96.56C97.3275 97.9775 98.76 99 102 99H105V105Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54H76C72.14 54 69 50.86 69 47V40C69 36.14 72.14 33 76 33H83C86.86 33 90 36.14 90 40V47C90 50.86 86.86 54 83 54ZM76 39C75.4475 39 75 39.4475 75 40V47C75 47.5525 75.4475 48 76 48H83C83.5525 48 84 47.5525 84 47V40C84 39.4475 83.5525 39 83 39H76Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90C56.3825 90 51 84.6175 51 78C51 71.3825 56.3825 66 63 66C69.6175 66 75 71.3825 75 78C75 84.6175 69.6175 90 63 90ZM63 72C59.6925 72 57 74.6925 57 78C57 81.3075 59.6925 84 63 84C66.3075 84 69 81.3075 69 78C69 74.6925 66.3075 72 63 72Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78 81V78C78 74.0175 76.6675 70.3325 74.2475 67.6225C71.545 64.5975 67.615 63 62.88 63H47.9975V57H62.88C69.37 57 74.85 59.2925 78.72 63.6275C81.49 66.73 83.2475 70.69 83.805 75H96.055C100.137 75 101.995 72.51 101.995 70.195V46.6675C101.995 34.17 91.3075 24 78.1725 24H47.995V18H78.1725C94.6175 18 107.995 30.86 107.995 46.6675V70.195C107.995 76.355 102.863 81 96.055 81H77.995H78Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndergroundWinter);
export default __webpack_public_path__ + "static/media/UndergroundWinter.70f434d5.svg";
export { ForwardRef as ReactComponent };